import React, {useCallback, useEffect, useState} from 'react'
import Text from '@component/Text/Text'
import {useRouter} from 'next/router'
import Link from 'next/link'

interface IProps {
    text: string
    href: string
    matchingCondition?: IMatchingCondition[]
    prefetch?: boolean
    textClassName?: string
    containerClassName?: string
    renderRightArea?: JSX.Element
    onClick?: (event: React.MouseEvent<HTMLAnchorElement | MouseEvent>) => void
}

export interface IMatchingCondition {
    type: MatchingType
    url: string
    query?: {}
}

export enum MatchingType {
    StartWith = 'StartWith',
    Equal = 'Equal',
}

const WizNavButton: React.FC<IProps> = ({
    text,
    href,
    matchingCondition = [],
    textClassName,
    containerClassName,
    renderRightArea,
    onClick,
}) => {
    const router = useRouter()

    const [isActive, setIsActive] = useState(false)

    useEffect(() => {
        if (isMatchConditions()) {
            setIsActive(true)
        } else {
            setIsActive(false)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.pathname])

    const isMatchCondition = useCallback(
        (condition: IMatchingCondition): boolean => {
            switch (condition.type) {
                case MatchingType.StartWith:
                    if (router.pathname.startsWith(condition.url)) return true
                    break
                case MatchingType.Equal:
                    if (router.pathname === condition.url) return true
                    break
            }
            return false
        },
        [router.pathname],
    )

    const isMatchConditions = (): boolean => {
        for (const condition of matchingCondition) {
            if (isMatchCondition(condition)) {
                return true
            }
        }
        return false
    }

    return (
        <Link suppressHydrationWarning={true} href={href} className={`${containerClassName}`} onClick={onClick}>
            <div
                className={`mx-[20px] sm:mx-2 border-b-[3px] flex gap-x-[5px] w-fit ${
                    isActive ? 'border-gray01 dark:border-dark_gray01' : 'border-transparent'
                } pt-[10px] pb-[10px]`}>
                <Text
                    className={`text-ti1 break-all ${
                        isActive ? 'text-gray01 dark:text-dark_gray01' : 'text-gray03 dark:text-dark_gray03'
                    } ${textClassName}`}>
                    {text}
                </Text>
                {renderRightArea}
            </div>
        </Link>
    )
}

export default WizNavButton
